/**
 * User Domain Types
 * Defines user-related types including roles, subscriptions, and permissions
 */
/**
 * User role enum defining the subscription level
 */
export var UserRole;
(function (UserRole) {
    UserRole["FREE"] = "free";
    UserRole["PREMIUM"] = "premium";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
/**
 * Subscription type enum for payment plans
 */
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["FREE"] = "free";
    SubscriptionType["MONTHLY"] = "monthly";
    SubscriptionType["ANNUAL"] = "annual";
})(SubscriptionType || (SubscriptionType = {}));
/**
 * Subscription status enum
 */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELLED"] = "cancelled";
    SubscriptionStatus["EXPIRED"] = "expired";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/**
 * Permission levels for secondary users
 * - VIEW: Read-only access
 * - MANAGE: Can add/edit/delete operations
 * - CONFIGURE: Full access (same as primary user)
 */
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["VIEW"] = "view";
    PermissionLevel["MANAGE"] = "manage";
    PermissionLevel["CONFIGURE"] = "configure";
})(PermissionLevel || (PermissionLevel = {}));
//# sourceMappingURL=user.js.map